/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Awesome_You_Will_Now_ReceiveInputs */

const en_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awesome! You will now receive live updates.`)
};

const es_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Increíble! Ahora recibirás actualizaciones en vivo.`)
};

const fr_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génial ! Vous recevrez désormais des mises à jour en direct.`)
};

const de_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Großartig! Du erhältst jetzt Live-Updates.`)
};

const ja_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`素晴らしい！これでリアルタイムの更新を受け取ることができます。`)
};

const zh_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太棒了！您现在将收到实时更新通知。`)
};

const ar_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رائع! ستتلقى الآن تحديثات مباشرة.`)
};

const id_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luar biasa! Anda sekarang akan menerima pembaruan langsung.`)
};

const it_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantastico! Ora riceverai aggiornamenti in tempo reale.`)
};

const ru_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отлично! Теперь вы будете получать оперативные обновления.`)
};

const pt_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrível! Você agora receberá atualizações ao vivo.`)
};

const ko_awesome_you_will_now_receive = /** @type {(inputs: Awesome_You_Will_Now_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`좋습니다! 이제 라이브 업데이트를 받을 수 있습니다.`)
};

/**
* | output |
* | --- |
* | "Awesome! You will now receive live updates." |
*
* @param {Awesome_You_Will_Now_ReceiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const awesome_you_will_now_receive = /** @type {((inputs?: Awesome_You_Will_Now_ReceiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Awesome_You_Will_Now_ReceiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_awesome_you_will_now_receive(inputs)
	if (locale === "es") return es_awesome_you_will_now_receive(inputs)
	if (locale === "fr") return fr_awesome_you_will_now_receive(inputs)
	if (locale === "de") return de_awesome_you_will_now_receive(inputs)
	if (locale === "ja") return ja_awesome_you_will_now_receive(inputs)
	if (locale === "zh") return zh_awesome_you_will_now_receive(inputs)
	if (locale === "ar") return ar_awesome_you_will_now_receive(inputs)
	if (locale === "id") return id_awesome_you_will_now_receive(inputs)
	if (locale === "it") return it_awesome_you_will_now_receive(inputs)
	if (locale === "ru") return ru_awesome_you_will_now_receive(inputs)
	if (locale === "pt") return pt_awesome_you_will_now_receive(inputs)
	return ko_awesome_you_will_now_receive(inputs)
});